(() => {
  const banner = document.querySelector('.media-banner');
  if (!banner) return;

  const medias = banner.querySelectorAll('.media-banner__media');
  
  const setLoaded = () => {
    banner.classList.add('is-loaded');
  };

  medias.forEach((media) => {
    if (media.tagName === 'IMG') {
      if (media.complete) {
        setLoaded();
      } else {
        media.addEventListener('load', setLoaded);
      }
    } else if (media.tagName === 'VIDEO') {
      if (media.readyState >= 2) {
        setLoaded();
      } else {
        media.addEventListener('loadeddata', setLoaded);
      }
    }
  });

  // Safeguard fallback to remove skeleton loader after 4 seconds
  setTimeout(setLoaded, 4000);
})();